import { Col, Modal, Progress, Row, TableColumnType, message } from "antd";
import { useQuery } from "react-query";
import { fetchTask, sFetchTask } from "../../../../apis/Task";
import useModals from "../../../../hooks/useModals";
import { SppedMateHttpError } from "../../../../network/speedMateError";
import { theme } from "../../../../theme";
import StatusDiv from "../../../molecures/StatusDiv";
import { TableForm } from "../../Table";
import { CustomCard } from "../Detail/Card.styled";

interface JobTaskFormProps {
  taskId?: string;
  isSpecial?: boolean;
  onClose: () => void;
}

export const JobTaskForm: React.FC<JobTaskFormProps> = ({
  taskId,
  isSpecial = false,
  onClose = () => void 0,
}) => {
  const { closeModal } = useModals();
  const { data } = useQuery(
    ["JobTasks", taskId],
    () => (isSpecial ? sFetchTask(taskId) : fetchTask(taskId)),
    {
      enabled: !!taskId,
      refetchIntervalInBackground: true,
      refetchInterval: (data) => {
        return data &&
          data?.rows.filter((res: any) => !!res.returnStatus).length !==
            data.count
          ? 1000
          : false || false;
      },
      onError: (err: SppedMateHttpError) => {
        message.error(err.notTranslate);
      },
    }
  );

  const columns: TableColumnType<any>[] = [
    {
      title: "진행상태",
      key: "returnStatus",
      width: 95,
      render: (value, record) => {
        switch (record.returnStatus) {
          case "FAIL":
            return <StatusDiv color={theme.colors.red3}>실패</StatusDiv>;
          case "SUCCESS":
            return <StatusDiv isExposed>성공</StatusDiv>;
          default:
            return <StatusDiv isExposed={false}>준비</StatusDiv>;
        }
      },
    },
    {
      title: "주문번호",
      key: "uniqueNo",
      width: 156,
      render: (value, record) => {
        return record.uniqueNo;
      },
    },
    {
      title: "실패 사유",
      key: "failReason",
      width: 625,
      render: (value, record) => record.failReason || "-",
    },
  ];

  return (
    <Modal
      title="일괄 작업완료 요청 결과"
      width={940}
      centered
      okText="닫기"
      visible
      destroyOnClose
      cancelButtonProps={{ hidden: true }}
      onOk={() => {
        closeModal();
        onClose();
      }}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          {data && data.rows.length && (
            <Progress
              percent={
                (data.rows.filter((row: any) => row.returnStatus).length /
                  data.count) *
                100
              }
            />
          )}
        </Col>
        <Col span={24}>
          <CustomCard title="예약주문별 작업요청 상태" bordered={false}>
            <TableForm
              columns={columns}
              dataSource={data?.rows || []}
              pagination={false}
            />
          </CustomCard>
        </Col>
      </Row>
    </Modal>
  );
};
